// Utility to handle localStorage quota exceeded errors
export const clearOldStorageData = () => {
  try {
    // Clear all non-essential localStorage items first
    const essentialKeys = ['persist:root'];
    const allKeys = Object.keys(localStorage);
    
    // Remove non-essential items
    allKeys.forEach(key => {
      if (!essentialKeys.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    
    // If still having issues, clear persist data too
    const persistData = localStorage.getItem('persist:root');
    if (persistData) {
      try {
        const parsedData = JSON.parse(persistData);
        if (parsedData && typeof parsedData === 'object') {
          // Keep only user and essential slices
          const essentialSlices = ['user', '_persist'];
          Object.keys(parsedData).forEach(key => {
            if (!essentialSlices.includes(key)) {
              delete parsedData[key];
            }
          });
          localStorage.setItem('persist:root', JSON.stringify(parsedData));
        }
      } catch (e) {
        // If all else fails, clear everything
        localStorage.clear();
      }
    }
  } catch (error) {
    console.warn('Error clearing old storage data:', error);
    // Last resort - clear everything
    localStorage.clear();
  }
};

export const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    if (error.name === 'QuotaExceededError') {
      console.warn('LocalStorage quota exceeded, clearing old data...');
      clearOldStorageData();
      try {
        localStorage.setItem(key, value);
      } catch (retryError) {
        console.warn('Failed to store data even after cleanup, skipping persist');
        // Don't throw error, just skip persisting this time
      }
    } else {
      console.error('LocalStorage error:', error);
    }
  }
};